<template>
  <div class="tableBtn">
    <b-button id="addBtn" size="sm" @click="onClick"
      ><slot><i class="bi bi-plus-square addBtnIcon"></i></slot
    ></b-button>
  </div>
</template>

<script>
export default {
  name: 'AddButton',
  methods: {
    onClick() {
      this.$emit('clickEvent')
    }
  }
}
</script>

<style lang="scss" scoped>
$icon-color: white;

.addBtnIcon {
  font-size: 16px;
  color: $icon-color;
}
</style>
